export default {"src":"/_next/static/media/fatigueDetection2.815bf60e.svg","height":1013,"width":1006,"blurWidth":0,"blurHeight":0};